module.exports = "<style>\r\n.myApp {\r\n  height: 100vh; /* this will cover all the window height */\r\n}\r\n</style>\r\n<div class=\"myApp\">\r\n  <div class=\"tilecontainer\">\r\n    <!-- Here all the tiles code -->\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/tilesHtml.html
 ** module id = 273
 ** module chunks = 0
 **/